import { Col, Row } from "antd";
import { labelStyle, SwitchContainer } from "./styles";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";

const BannerMobileInfo = () => {
	const { bannerMobileForm, setBannerMobileForm } = useBannerMobileContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={8}>
					<SwitchContainer>
						<SwitchOptionComponent
							key={"isActive"}
							title={"Aktif"}
							labelStyle={labelStyle}
							value={bannerMobileForm?.isActive}
							onChange={(checked) => setBannerMobileForm({ ...bannerMobileForm, isActive: checked })}
						/>
					</SwitchContainer>
				</Col>
			</Row >
		</>
	);
};

export default BannerMobileInfo;
